import {
  BlockStack,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Divider,
  InlineGrid,
  Tag,
  Text,
} from "@shopify/polaris";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const countriesList = [
  "Algeria",
  "Angola",
  "Argentina",
  "Australia",
  "Austria",
  "Bahrain",
  "Bangladesh",
  "Belarus",
  "Belgium",
  "Brazil",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Cote d'Ivoire",
  "Czechia",
  "Denmark",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Ethiopia",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Guatemala",
  "Hong Kong",
  "Hungary",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kuwait",
  "Lebanon",
  "Madagascar",
  "Malaysia",
  "Mauritius",
  "Mexico",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Nigeria",
  "Norway",
  "Oman",
  "Panama",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "Senegal",
  "Singapore",
  "Slovakia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Tunisia",
  "Turkey",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "Zambia",
  "Zimbabwe",
];

const ManageAdditionalCountries = () => {
  const [selectedCountries, setSelectedCountries] = useState({});
  const [modifiedCountries, setModifiedCountries] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const paramValue = urlParams.get("shop");

  // Fetch existing additional countries from backend
  useEffect(() => {
    const fetchAdditionalCountries = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/store/settings?shop=${paramValue}`
        );
        const data = await response.json();
        const parseSettings = data.data;
        if (parseSettings.additionalCountries) {
          const savedCountries = parseSettings.additionalCountries || [];
          const countrySelection = {};
          savedCountries.forEach((country) => {
            countrySelection[country] = true;
          });
          setSelectedCountries(countrySelection);
        }
      } catch (error) {
        console.error("Error fetching additional countries:", error);
      }
    };

    fetchAdditionalCountries();
  }, [paramValue]);

  const handleCheckboxChange = (country) => {
    setSelectedCountries((prev) => ({
      ...prev,
      [country]: !prev[country],
    }));

    setModifiedCountries((prev) => ({
      ...prev,
      [country]: true,
    }));
  };

  const handleSave = async () => {
    const modifiedCountryNames = Object.keys(selectedCountries).filter(
      (country) => selectedCountries[country]
    );

    const settings = {
      additionalCountries: modifiedCountryNames,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/shopify/store/update_settings?shop=${paramValue}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ settings }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        console.log("Additional Countries updated successfully:", result);
        alert("Additional Countries updated successfully!");
      } else {
        console.error("Error updating additional countries:", result);
        alert("Failed to update additional countries!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while updating additional countries.");
    }

    setModifiedCountries({});
  };

  const handleCancel = () => {
    navigate(`/tab-settings?shop=${paramValue}`);
  };

  return (
    <Card>
      <BlockStack gap="150" inlineAlign="space-evenly">
        <Text variant="headingXl" fontWeight="semibold" as="h5">
          Manage Additional Countries (For Google Only)
        </Text>

        <Divider />
        <InlineGrid gap="2000" columns={["twoThirds", "oneThird"]}>
          <InlineGrid columns={["oneHalf", "oneHalf"]}>
            <Text variant="headingMd" as="h6">
              Action
            </Text>
            <Text variant="headingMd" as="h6">
              Country Name
            </Text>
          </InlineGrid>
          <Text variant="headingMd" as="h6">
            Status
          </Text>
        </InlineGrid>
        <Divider />

        {countriesList.map((country) => (
          <React.Fragment key={country}>
            <InlineGrid gap="2000" columns={["twoThirds", "oneThird"]}>
              <InlineGrid columns={["oneHalf", "oneHalf"]}>
                <Checkbox
                  checked={selectedCountries[country] || false}
                  onChange={() => handleCheckboxChange(country)}
                />
                <Text variant="bodyMd" as="p">
                  {country}
                </Text>
              </InlineGrid>
              <Text as="p">
                {modifiedCountries[country] ? <Tag>Unsaved</Tag> : ""}
              </Text>
            </InlineGrid>
            <Divider />
          </React.Fragment>
        ))}

        <ButtonGroup>
          <Button variant="primary" onClick={handleSave}>
            Save Additional Countries
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </ButtonGroup>
      </BlockStack>
    </Card>
  );
};

export default ManageAdditionalCountries;
